import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { useMemo } from 'react';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { ConversionRate, LeadsRowData, overdueColumns, TotalCalls, undueColumns } from '../services/entity';
export default function LeadsCatalog(props) {
    var _a = props.name, name = _a === void 0 ? '' : _a, value = props.value, onChange = props.onChange;
    var filterValue = value === null || value === void 0 ? void 0 : value[name + 'Filter'];
    var columns = [];
    if (['ServiceDue', 'CrossSell'].includes(name)) {
        columns = undueColumns;
    }
    if (['OverdueService', 'OverdueCross'].includes(name)) {
        columns = overdueColumns;
    }
    var rows = useMemo(function () {
        var Factor = filterValue ? Math.random() : 1;
        var totals = Object.entries(TotalCalls[name]).reduce(function (acc, _ref) {
            var key = _ref[0], val = _ref[1];
            acc[key] = Math.ceil(val * Factor);
            return acc;
        }, {});
        var conversions = _objectSpread({}, ConversionRate[name]);
        var appointments = Object.entries(conversions).reduce(function (acc, _ref2) {
            var key = _ref2[0], val = _ref2[1];
            acc[key] = Math.ceil(totals[key] * val);
            conversions[parseInt(key)] = Math.ceil(conversions[parseInt(key)] * 100);
            return acc;
        }, {});
        var calls = Object.entries(appointments).reduce(function (acc, _ref3) {
            var key = _ref3[0], val = _ref3[1];
            acc[key] = Math.ceil((totals[key] + val) / 2);
            return acc;
        }, {});
        var res = [_objectSpread(_objectSpread({}, LeadsRowData[0]), totals), _objectSpread(_objectSpread({}, LeadsRowData[1]), calls), _objectSpread(_objectSpread(_objectSpread({}, LeadsRowData[2]), appointments), {}, {
                Particulars: name.includes('Cross') ? 'Interested' : 'Appointments scheduled'
            }), _objectSpread(_objectSpread({}, LeadsRowData[3]), conversions)];
        return res;
    }, [name, filterValue]);
    return /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        rows: rows,
        dataGridProps: {
            hideFooter: true,
            disableColumnMenu: true,
            disableColumnSorting: true,
            columnHeaderHeight: 72,
            onColumnHeaderClick: function (_ref4, e) {
                var field = _ref4.field;
                if (name.includes('Service'))
                    onChange === null || onChange === void 0 || onChange(e, field);
            },
            sx: {
                borderRadius: 0,
                border: 'none'
            }
        }
    });
}
